import { Link } from "react-router-dom";
import {
  Mail,
  MessageCircle,
  LifeBuoy,
  Clock,
  Users,
  Headphones,
} from "lucide-react";

const Support = () => {
  return (
    <div className="bg-white text-black font-sans">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-white to-[#F5F5F5] px-6 py-32 text-center">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-4 leading-tight text-black">
            We’re Here to Help
          </h1>
          <p className="text-lg md:text-xl text-[#666666] mb-6 max-w-2xl mx-auto">
            Our team is dedicated to supporting you 7 days a week with fast,
            reliable assistance. Whether you need help or have a question, we’ve
            got you covered.
          </p>
          <img
            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80"
            alt="Support team"
            className="rounded-xl shadow-sm mx-auto mt-8 max-w-md"
          />
        </div>
      </section>

      {/* Support Options */}
      <section className="px-6 py-32 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold mb-12 text-center text-black">
            How Can We Assist You?
          </h2>
          <div className="space-y-6">
            {/* Visit Help Center - Fully Clickable */}
            <Link
              to="/faq"
              className="flex items-start gap-4 border border-gray-200 p-5 rounded-xl hover:shadow-md transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <LifeBuoy className="w-6 h-6 text-[#FF5A5F] mt-1" />
              <div>
                <h3 className="font-semibold text-lg text-black">
                  Visit Help Center
                </h3>
                <p className="text-sm text-[#666666]">
                  Find answers to common questions in our FAQs. Browse articles
                  on setup, troubleshooting, and more.
                </p>
              </div>
            </Link>

            {/* Email Support - Fully Clickable */}
            <a
              href="mailto:support@fullplatenow.com"
              className="flex items-start gap-4 border border-gray-200 p-5 rounded-xl hover:shadow-md transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <Mail className="w-6 h-6 text-[#FF5A5F] mt-1" />
              <div>
                <h3 className="font-semibold text-lg text-black">
                  Email Support
                </h3>
                <p className="text-sm text-[#666666]">
                  Reach out at support@fullplatenow.com. Expect a response
                  within 1 business day, often sooner.
                </p>
              </div>
            </a>

            {/* Live Chat - Placeholder (Fully Clickable) */}
            <a
              href="mailto:support@fullplatenow.com"
              className="flex items-start gap-4 border border-gray-200 p-5 rounded-xl hover:shadow-md transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <MessageCircle className="w-6 h-6 text-[#FF5A5F] mt-1" />
              <div>
                <h3 className="font-semibold text-lg text-black">Live Chat</h3>
                <p className="text-sm text-[#666666]">
                  Live chat support is coming soon! For now, email us at
                  support@fullplatenow.com for immediate assistance.
                </p>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Why Choose Our Support */}
      <section className="px-6 py-32 bg-[#F5F5F5]">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold mb-12 text-center text-black">
            Why Choose Our Support?
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                title: "Fast Responses",
                desc: "Our team responds within hours during business hours, ensuring you get the help you need quickly.",
                icon: <Clock className="w-8 h-8 text-[#20C997] mb-4" />,
              },
              {
                title: "Dedicated Team",
                desc: "Our support team is passionate about helping restaurants succeed, offering personalized assistance.",
                icon: <Users className="w-8 h-8 text-[#20C997] mb-4" />,
              },
              {
                title: "Seamless Experience",
                desc: "Whether via email or our help center, we ensure a smooth and efficient support experience.",
                icon: <Headphones className="w-8 h-8 text-[#20C997] mb-4" />,
              },
            ].map((benefit, idx) => (
              <div
                key={idx}
                className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 text-center"
              >
                {benefit.icon}
                <h3 className="text-lg font-semibold mb-2 text-black">
                  {benefit.title}
                </h3>
                <p className="text-sm text-[#666666]">{benefit.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Hours */}
      <section className="px-6 py-16 bg-white text-center">
        <div className="max-w-7xl mx-auto">
          <h3 className="text-lg font-semibold text-black mb-2">
            Support Hours
          </h3>
          <p className="text-sm text-[#666666]">
            Business Hours: Monday–Friday, 9am–6pm PST
          </p>
          <p className="text-sm text-[#666666] mt-1">
            Support: Limited on weekends & holidays
          </p>
        </div>
      </section>
    </div>
  );
};

export default Support;
